import { render } from "./SurveyRelationships.vue?vue&type=template&id=0ad19eeb&ts=true"
import script from "./SurveyRelationships.vue?vue&type=script&lang=ts"
export * from "./SurveyRelationships.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__